<template>
    <title>{{ settings.applicationname }} - <slot></slot></title>
</template>

<script>

    import { mapGetters } from 'vuex'

    export default {
        props: {

        },
        computed: {
            ...mapGetters([
                'settings',
            ]),
        },

        created() {
            var titles = document.querySelectorAll('title')
            titles.forEach(title => {
                title.remove()
            })
        },
    }
</script>